import { Loader2 } from 'lucide-react';
import { cn } from '../cn';

export interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

export function Spinner({ size = 16, className, label = 'Carregando' }: SpinnerProps) {
  return (
    <Loader2
      className={cn('text-brand-500 animate-spin', className)}
      size={size}
      role="status"
      aria-label={label}
    />
  );
}
